// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__vteVN","buttons":"SendReceipts_buttons__33wxV","email":"SendReceipts_email__3aL7G","bookApptTitle":"SendReceipts_bookApptTitle__2oZuN"};